import React from 'react';
import { useInboxTranslation } from '../Hooks';

export interface InboxConfig {
    baseUrl: string;
    onTokenRequest: () => Promise<string>;
    loginEmail: string;
}

const InboxConfigContext = React.createContext<InboxConfig>({} as InboxConfig);

export interface InboxConfigProviderProps extends React.PropsWithChildren {
    baseUrl: string;
    onTokenRequest: () => Promise<string>;
    loginEmail: string;
}

const InboxConfigProvider: React.FC<InboxConfigProviderProps> = ({ children, ...props }) => {
    const { ready } = useInboxTranslation();
    return <InboxConfigContext.Provider value={props}>{ready && children}</InboxConfigContext.Provider>;
};

export { InboxConfigProvider };
export default InboxConfigContext;
